import { LabelChip, LabelChipProps, mergeSx } from '@cast/design-system';

export const SidebarItemBadge = ({ children, sx }: LabelChipProps) => (
  <LabelChip
    size="2xs"
    sx={mergeSx(
      {
        position: 'absolute',
        right: 0,
        top: 0,
        transform: 'translateX(100%)',
        backgroundColor: 'indigo.300',
        color: '#fff',
        mr: 'auto',
        alignSelf: 'flex-start',
        '& > *': {
          cursor: 'inherit',
        },
      },
      sx
    )}
  >
    {children}
  </LabelChip>
);
